import { render, staticRenderFns } from "./order.vue?vue&type=template&id=4a4e50a6&scoped=true"
import script from "./order.vue?vue&type=script&lang=js"
export * from "./order.vue?vue&type=script&lang=js"
import style0 from "./order.vue?vue&type=style&index=0&id=4a4e50a6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e50a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4e50a6')) {
      api.createRecord('4a4e50a6', component.options)
    } else {
      api.reload('4a4e50a6', component.options)
    }
    module.hot.accept("./order.vue?vue&type=template&id=4a4e50a6&scoped=true", function () {
      api.rerender('4a4e50a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mall/order.vue"
export default component.exports